import './App.css';
import {
  Switch,
  Route
} from "react-router-dom";
import Footer from './Component/Footer';
import Header from './Component/Header';
import ProjectPage from './Pages/ProjectPage';
import HomePage from './Pages/HomePage';
import ContactPage from './Pages/ContactPage';
import NotFound from './Pages/NotFound';
import { useEffect, useState } from 'react';
import { FlexCol, FlexRow } from './Styles';
import loadingIcon from './assets/Others/Loader2.gif';
import { primaryBgColor } from './Constant/constant';
import { init } from 'emailjs-com';


function App() {

  const [isLoading, setloading] = useState(true);
  const [screenBig, setscreenBig] = useState(true);

  const resizeWindow = () => {
    if (window.innerWidth > 1000) {
      setscreenBig(true)
    } else {
      setscreenBig(true)
      // setscreenBig(false)
    }
  }

  useEffect(() => {
    init("user_vzFsDHAQ1XBE2eIdMzpuV");
    setTimeout(function () { setloading(false) }, 3000);

    // window.addEventListener("resize", resizeWindow);
  }, [])

  // console.log(1, window.innerWidth)
  // console.log(2, window.outerWidth)
  // console.log(3, window.screen.availWidth)

  // if (!screenBig) {
  //   return (
  //     <FlexRow>
  //       <FlexCol basis="40%">
  //         <br />
  //         <br />
  //         <br />
  //         <h1>Not Supported! Kindly Use a desktop browser or screen size greater than 1000 pixel</h1>
  //       </FlexCol>
  //     </FlexRow>
  //   )
  // }
  return (
    <div className="background-color">
      {isLoading &&
        <FlexRow style={{ position: 'absolute', top: 0, bottom: 0, width: '-webkit-fill-available', background: primaryBgColor, zIndex: 50 }}>
          <FlexCol basis="20%" style={{ textAlign: 'center' }}>
            <img
              style={{ width: 160, height: 'auto', objectFit: 'scale-down' }}
              src={loadingIcon}
              alt="loading icon" />
          </FlexCol>
        </FlexRow>
      }
      {!isLoading &&
        <Switch>
          <Route exact path="/">
            <Header selected="HOME" />
            <HomePage />
          </Route>
          <Route path="/projects" >
            <Header selected="PROJECT" />
            <ProjectPage />
          </Route>
          <Route path="/contact">
            <Header selected="CONTACT" />
            <ContactPage />
          </Route>
          <Route path="/sitemap" component={() => {
            window.location.replace(process.env.PUBLIC_URL + '/sitemap.xml')
            return null;
          }} />
          <Route>
            <Header />
            <NotFound />
          </Route>
        </Switch >
      }
      <Footer />
    </div >
  );
}

export default App;
